module.exports = __webpack_public_path__ + "static/media/video-store-virtualization.e3cb792e.mp4";